/* eslint-disable react/display-name */
/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */

import Link from 'next/link';
import { sanityClient, PortableText, urlFor } from '../../lib/sanity';

import styles from '../../styles/Home.module.scss';
import AccordionStyles from '../../styles/navigation/GenAccordionStyles.module.scss';

import StandardLayout from '../../components/layouts/StandardLayout';
import IntroCopyBlock from '../../components/elements/IntroCopyBlock';
import Spacer from '../../components/elements/Spacer';

import Partnersitems from '../../components/elements/Partnersitems';
import WhiteBlueIllustration from '../../components/elements/WhiteBlueIllustration';
import Videothumbblock from '../../components/elements/Videothumbblock';
import GreenQuote from '../../components/GreenQuote';

const toursPageQuery = `
{"openProcessQuery": *[_id=="7da4f181-70cb-4cb5-bab2-349342910cfd"] {
  title,
  meta,
  introheading,
  introcopy,
  pagequote,
  pinkmessage,
  paragraphs,
  customblocks,
  headerimage,
},
  "companyInfoQuery" : *[_type=="company"] {
    overlaytitle,
    message,
    title,
    footer,
    sociallinks,
    email,
    numbers
  },

  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    linkaddress,
    "manuscriptURL": manuscript.asset->url,
    mapimage
  },
  "toursQuery" : *[_type=="virtualtours"]  |  order(_createdAt asc) {
    name,

    slug,
    touritem
  },


}
`;

const serializers = {
  marks: {
    link: ({ children, mark }) =>
      mark.blank ? (
        <a href={mark.href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={mark.href}>{children}</a>
      )
  }
};

export default function ourPartners({ openProcessQuery, companyInfoQuery, nurseryQuery, toursQuery }) {
  const PageInfo = openProcessQuery[0];

  const Company = companyInfoQuery;
  const Nurseries = nurseryQuery;
  const Vacancies = PageInfo.paragraphs.slice(0, 4);
  const Tours = toursQuery;
  const PageQuote = PageInfo.pagequote;

  return <>
    <StandardLayout CompanyInfo={Company} Nurseries={Nurseries} PageInfo={PageInfo} headerWidth={1920} headerHeight={600} headerMinHeight={300} hideLeadImage={false} hideLink={true}>
      <div className={styles.mainContent}>
        <div className="container">
          <IntroCopyBlock PageInfo={PageInfo} />
          <Spacer mt={2} />
        </div>

        <div className="container">
          <div className={styles.buttonStyler} style={{ margin: `0 auto` }}>
            <Link href={'/admissions/nursery-tour-booking'}>
              <button className={styles.telTo}>Book Your Tour</button>
            </Link>
          </div>

          {Tours?.length > 0 &&
            Tours.map((tour, index) => (
              <div key={index}>
                <Spacer mt={4} />
                <h2 className="text-center">{tour.name}</h2>
                <div className={`flexedholder row${index + 1}`}>
                  {tour.touritem?.length > 0 &&
                    tour.touritem.map((touritem) => (
                      <div className="flexitem" key={touritem._key}>
                        <Videothumbblock Content={touritem} />
                      </div>
                    ))}
                </div>
              </div>
            ))}

          {/* <Videothumbblock BlockContent={Test}/> */}

          <Spacer mt={2} />
          <div className={AccordionStyles.holder}>
            <div className={AccordionStyles.row}>
              <div className={AccordionStyles.col}>
                <div className={AccordionStyles.tabs}>
                  {Vacancies?.length > 0 &&
                    Vacancies.map((vacancy, index) => (
                      <div className={AccordionStyles.tab} key={index}>
                        <input type="checkbox" id={`partner${index + 1}`} />
                        <label className={AccordionStyles.tablabel} htmlFor={`partner${index + 1}`}>
                          <div className={AccordionStyles.standardLink}>{vacancy.title}</div>
                        </label>
                        <div className={AccordionStyles.tabcontent}>
                          <PortableText blocks={vacancy.paragraphcopy} serializers={serializers} />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          <Spacer mt={4} />

          <h2>Availibility</h2>
          <PortableText blocks={PageInfo.paragraphs[4].paragraphcopy} serializers={serializers} />
          <Spacer mt={3} />

          <div className="halfgrid">
            <div className="firsthalf">
              <h3>More2Riverside</h3>
              <PortableText blocks={PageInfo.paragraphs[5].paragraphcopy} serializers={serializers} />
            </div>
            <div className="secondhalf">
              <h3>More2ChildCare</h3>
              <PortableText blocks={PageInfo.paragraphs[6].paragraphcopy} serializers={serializers} />
            </div>
          </div>
        </div>
      </div>

      {PageQuote && <GreenQuote quote={PageQuote} />}
      <WhiteBlueIllustration />
    </StandardLayout>
  </>;
}

export async function getStaticProps() {
  const { openProcessQuery, companyInfoQuery, nurseryQuery, toursQuery } = await sanityClient.fetch(toursPageQuery);
  return { props: { openProcessQuery, companyInfoQuery, nurseryQuery, toursQuery } };
}
